import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { storage as mmkv } from './mmkv-store';
import { createGeneralSlice } from './slices/general';
import { createJumpSlice } from './slices/jump';
import { createReaderSlice } from './slices/reader';
import { createSpeedSlice } from './slices/speed';
import { createSystemSlice } from './slices/system';
import { readerSettingsToPreferences } from './migrations';
export const storage = {
    getItem: (key) => mmkv.getString(key) || null,
    setItem: (key, value) => mmkv.set(key, value),
    removeItem: (key) => mmkv.delete(key),
};
export const useSettingsStore = create()(persist((...props) => ({
    ...createGeneralSlice(...props),
    ...createJumpSlice(...props),
    ...createReaderSlice(...props),
    ...createSpeedSlice(...props),
    ...createSystemSlice(...props),
}), {
    name: 'settings-storage',
    version: 2,
    migrate: (persisted, version) => {
        let newState = persisted;
        if (!version || version < 2) {
            newState = readerSettingsToPreferences(newState);
        }
        return newState;
    },
    storage: createJSONStorage(() => storage),
}));
//# sourceMappingURL=useSettingsStore.js.map